// eslint-disable-next-line import/no-internal-modules
import { WidgetContainerConfig } from '@insided/deprecated-preact-components/widget-container'
import { Component } from 'preact'
import { getCssVarLabel } from '../../ThemeConfigurator'
import Field from './FieldContainer'
import { AbstractFieldProps } from './types'

type DescriptionColorDisplayValue = WidgetContainerConfig['descriptionColorDisplay']

export interface DescriptionColorDisplayFieldProps
  extends AbstractFieldProps<DescriptionColorDisplayValue> {}

interface FieldState {
  value: DescriptionColorDisplayValue
}

interface Option {
  value: DescriptionColorDisplayValue
  label: string
}

export const DESCRIPTION_DISPLAY_OPTIONS: Option[] = [
  {
    value: 'config--main-color-night',
    label: getCssVarLabel('config--main-color-night')
  },
  {
    value: 'config-header-color',
    label: getCssVarLabel('config-header-color')
  },
  {
    value: 'solid_color',
    label: 'Custom solid color'
  }
]

const INPUT_ID = 'widget-description-color'

export class DescriptionColorDisplayField extends Component<
  DescriptionColorDisplayFieldProps,
  FieldState
> {
  state = {
    value: this.props.value ?? DESCRIPTION_DISPLAY_OPTIONS[0].value
  }

  render() {
    return (
      <Field inputId={INPUT_ID} title='Description color'>
        <select
          id={INPUT_ID}
          name={INPUT_ID}
          onChange={(event) => {
            const value = (event.target as HTMLSelectElement).value as DescriptionColorDisplayValue
            this.setState({ value }, () => this.props.onValueChange(value))
          }}
        >
          {DESCRIPTION_DISPLAY_OPTIONS.map(({ value, label }) => (
            <option key={value} value={value} selected={this.state.value === value}>
              {label}
            </option>
          ))}
        </select>
      </Field>
    )
  }
}

export default DescriptionColorDisplayField
